var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FastField, Field, getIn } from "formik";
import { flatten } from "@reside/forms/dist/flatten";
import * as immutable from "object-path-immutable";
export var getFormFieldComponent = function (name, options) {
    if (!Array.isArray(options)) {
        return isFastFieldCapable(name) ? FastField : Field;
    }
    return isFastFieldCapable(name) && !options.some(function (option) { return option.children; })
        ? FastField
        : Field;
};
/**
 * Fast field can not be used when field is dependant on other field values
 */
export var isFastFieldCapable = function (name) { return !isArrayField(name); };
var isArrayField = function (name) { return name.includes("."); };
export var isInvalid = function (fieldName, form) {
    return getFormFieldError(fieldName, form) && isFormFieldTouched(fieldName, form);
};
export var getFormFieldError = function (fieldName, form) {
    return immutable.get(form.errors, fieldName) ||
        getIn(form.errors, fieldName) ||
        form.errors[fieldName];
};
var isFormFieldTouched = function (fieldName, form) {
    // nested fields that are visible only if json logic is true are not registered and formik can not properly mark them as touched
    return form.submitCount > 0 ||
        immutable.get(form.touched, fieldName) ||
        getIn(form.touched, fieldName) ||
        Object.prototype.hasOwnProperty.call(flatten(form.touched), fieldName);
};
/**
 * Constructs the FILE variable which can be saved to facility settings.
 */
export var makeFileVariable = function (data) { return (__assign(__assign({}, data), { type: "FILE" })); };
export var getPreSignedUrl = function (originalUrl, transformUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var fileUrl, response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fileUrl = originalUrl.replace("".concat(process.env.REACT_APP_API_URL, "/files/"), "".concat(process.env.REACT_APP_API_GATEWAY_URL, "/v3/files/"));
                return [4 /*yield*/, fetch(transformUrl(fileUrl))];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Failed to fetch pre-signed URL: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data.url];
        }
    });
}); };
